import Coleta from "model/transportes/coleta/Coleta";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import ColetaService from "service/transportes/ColetaService";
import RotaService from "service/transportes/RotaService";
import { converterDataHora } from "utils/convert";

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: (coleta: Coleta) => void;
}

const rotasService = new RotaService();
export default function ModalSelecionarColeta(props: Props) {

    const [coletas, setColetas] = useState<Coleta[]>([]);
    const [coletaSelecionada, setColetaSelecionada] = useState<Coleta | null>(null);

    useEffect(() => {
        rotasService.coletas().then((data) => {
            setColetas(data);
        }).catch(err => {
            console.log(err);
        });
    }, [])

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onHide} />
        <Button label="Confirmar" icon="pi pi-check" className="p-button-text" onClick={() => coletaSelecionada ? props.onConfirm(coletaSelecionada) : null} />
    </div>

    return (
        <Dialog
            header="Selecione uma coleta"
            visible={props.visible}
            baseZIndex={500} style={{ width: '50vw' }}
            onHide={props.onHide} footer={footer}>
            <DataTable
                emptyMessage="Nenhuma coleta encontrada"
                value={coletas}
                selectionMode="single"
                selection={coletaSelecionada!}
                onSelectionChange={(e: any) => {
                    setColetaSelecionada(e.value);
                }}
                dataKey={"id"}

            >
                <Column field="numero" header="Número" />
                <Column field="dataPrevista" header="Data" body={(rowData) => converterDataHora(rowData.dataPrevista)} />
                <Column field="cliente.nome" header="Cliente" />
                <Column field="endereco.estado" header="Estado" />
                <Column field="endereco.cidade" header="Cidade" />
            </DataTable>

        </Dialog>
    );
}